export const shouldLoad = () => !!document.querySelector('[data-controller=content-archive]');
